@if (text || htmlContent) {
<div
  class="tooltip-container style-{{ style }} size-{{ size }} position-{{ position }}"
  [style.top]="top + 'px'"
  [style.left]="left + 'px'"
  [style.right]="right + 'px'"
  [class.bottom]="bottom"
>
  <div class="tooltip" [@tooltip]>
    @if (imageUrl) {
    <img [src]="imageUrl" alt="" />
    } @if (title) {
    <h3>{{ title }}</h3>
    } @if (!htmlContent) {
    <div>
      {{ text }}
      @if (keyboardShortcut) {
      <span class="shortcut">
        @if (keyboardShortcutMeta) {
        <span>{{ metaKey }}+</span>
        }
        {{ keyboardShortcut }}</span
      >
      }
    </div>
    } @if (htmlContent) {
    <div [innerHTML]="htmlContent"></div>
    }
  </div>
</div>
}
